import { createSlice } from '@reduxjs/toolkit';
import { handleRequestThunk } from '../../../handleRequestThunk';
import { getSuspensionState } from '../../thunks/vehicleProThunks';
import { commonInitialState } from '../../../../../utils/common/commonInitialState';
import { clearVehicleProKey } from '../../thunkKeys/vehicleProThunksKeys';

const SLICE_NAME = 'suspensionState';

export const suspensionStateSlice = createSlice({
    name: SLICE_NAME,
    initialState: structuredClone(commonInitialState),
    reducers: {
        clearSuspensionState(state) {
            state.data = [];
        },
    },
    extraReducers: (builder) => {
        handleRequestThunk({ builder, request: getSuspensionState });
        builder.addCase(
            clearVehicleProKey,
            () => commonInitialState,
        );
    },
});

export const { clearSuspensionState } = suspensionStateSlice.actions;

export const suspensionState = suspensionStateSlice.reducer;
